import { DefaultApi } from "@vviinn/user-managment-client-ts";
import { createContext, FC, useContext, useCallback } from "react";
import { createApi, createAnonymousApi } from "../api";
import { useAuth } from "../auth";

type ApiContext = {
  getApi: () => Promise<DefaultApi>;
  getAnonymousApi: () => Promise<DefaultApi>;
};

const apiContext = createContext<ApiContext>({
  getApi: () => Promise.reject(),
  getAnonymousApi: () => Promise.reject(),
});

const apiErrorMessage = "Could not create api object";

export const ApiProvider: FC<React.PropsWithChildren> = ({ children }) => {
  const { getToken, user } = useAuth();

  const getApi = useCallback(async () => {
    try {
      const token = await getToken();
      const api = createApi(token);

      return Promise.resolve(api);
    } catch (e) {
      return Promise.reject(apiErrorMessage);
    }
  }, [user]);

  const getAnonymousApi = useCallback(async () => {
    try {
      const api = createAnonymousApi();
      return Promise.resolve(api);
    } catch (e) {
      return Promise.reject(apiErrorMessage);
    }
  }, []);

  return (
    <apiContext.Provider value={{ getApi, getAnonymousApi }}>
      {children}
    </apiContext.Provider>
  );
};

export const useApi = () => useContext(apiContext);
